import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-101040d8")

_pushScopeId("data-v-101040d8")
const _hoisted_1 = { class: "TemplateCard" }
const _hoisted_2 = { class: "TemplateCard__header" }
const _hoisted_3 = { class: "header__title" }
const _hoisted_4 = { class: "TemplateCard__content" }
const _hoisted_5 = { class: "content__row" }
const _hoisted_6 = { class: "content__col" }
const _hoisted_7 = { class: "col__text" }
const _hoisted_8 = { class: "col__text" }
const _hoisted_9 = {
  key: 0,
  class: "col__text"
}
const _hoisted_10 = { class: "content__row" }
const _hoisted_11 = { class: "content__col" }
const _hoisted_12 = { class: "col__text" }
const _hoisted_13 = {
  key: 0,
  style: {"margin-top":"12px"}
}
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Самовывоз")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Самопривоз")
const _hoisted_16 = { class: "TemplateCard__footer" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Выбран")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Выбрать")
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Удалить ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_icon_edit = _resolveComponent("icon-edit")!
  const _component_icon_person = _resolveComponent("icon-person")!
  const _component_icon_location = _resolveComponent("icon-location")!
  const _component_new_button = _resolveComponent("new-button")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, _toDisplayString(_ctx.template.title), 1),
      (_ctx.isCanUpdate)
        ? (_openBlock(), _createBlock(_component_icon_edit, {
            key: 0,
            class: "header__update",
            onClick: _ctx.emitUpdate
          }, null, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _createVNode(_component_icon_person, { class: "row__icon" }),
        _createVNode("div", _hoisted_6, [
          _createVNode("p", _hoisted_7, _toDisplayString(_ctx.template.full_name), 1),
          _createVNode("p", _hoisted_8, _toDisplayString(_ctx.template.phone), 1),
          (_ctx.template.additional_phone)
            ? (_openBlock(), _createBlock("p", _hoisted_9, _toDisplayString(_ctx.template.additional_phone), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode("div", _hoisted_10, [
        _createVNode(_component_icon_location, { class: "row__icon" }),
        _createVNode("div", _hoisted_11, [
          _createVNode("p", _hoisted_12, _toDisplayString(_ctx.template.full_address), 1)
        ])
      ]),
      (_ctx.template.warehouse_id)
        ? (_openBlock(), _createBlock("p", _hoisted_13, [
            (_ctx.isReceiverTemplate)
              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                  _hoisted_14
                ], 64))
              : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                  _hoisted_15
                ], 64))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_16, [
      _createVNode(_component_new_button, {
        disabled: _ctx.selected || _ctx.disabled,
        class: "button--primary button--small",
        onClick: _ctx.emitSelect
      }, {
        default: _withId(() => [
          (_ctx.selected)
            ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                _hoisted_17
              ], 64))
            : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                _hoisted_18
              ], 64))
        ]),
        _: 1
      }, 8, ["disabled", "onClick"]),
      (_ctx.isCanDelete)
        ? (_openBlock(), _createBlock(_component_new_button, {
            key: 0,
            class: "button--primary button--small button--outline",
            onClick: _ctx.emitDelete
          }, {
            default: _withId(() => [
              _hoisted_19
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ])
  ]))
})